// extracted by mini-css-extract-plugin
module.exports = {"privacyContainer":"Privacy_privacyContainer__2SXFE","pageHeader":"Privacy_pageHeader__27MaR"};